module["exports"] = [
  "Apt. ###",
  "Suite ###"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/en/address/secondary_address.js
 ** module id = 404
 ** module chunks = 0
 **/